import jQuery from 'jquery';
import 'slick-carousel';

jQuery(($) => {
    if ($('.gallery:not([data-static])').length) {
        $('.gallery:not([data-static])').slick({
            dots: false,
            infinite: false,
            speed: 300,
            centerMode: false,
            variableWidth: true,
            adaptiveHeight: false,
        });
        // var lightbox = new PhotoSwipeLightbox({
        //     gallery: '.gallery',
        //     children: 'a',
        //     pswpModule: PhotoSwipe
        // });
        // lightbox.init();
    }
});
